export const WAGAMOUR_OPEN_RIDE_CHOOSER = 'wagamour:open-ride-chooser'

export type RideChooserOpenDetail = {
  lat: number
  lng: number
  title?: string
  city?: string | null
  region?: string | null
  userLat?: number
  userLng?: number
}

export const WAGAMOUR_PICKS_REQUEST_LOCATION = 'wagamour:picks-request-location'

/** Picks / Right Now: apply coords from in-page geolocation (listened in app-beta). */
export const WAGAMOUR_SET_LOCATION = 'wagamour:set-location'

/** Picks handoff: switch main shell tab and/or Picks sub-surface. Listened to in app-beta + PicksScreen. */
export const WAGAMOUR_PICKS_SHELL_NAVIGATE = 'wagamour:picks-shell-navigate'

export type PicksShellNavigateDetail = {
  tab?: 'parks' | 'picks'
  picksCategory?: import('@/lib/picks/picksActionTypes').PicksOrchestrationCategory
}
